import PropTypes from 'prop-types';
import React, { Component } from 'react';

require("./HorseRacingRacecardResultRunner.scss");

export default class HorseRacingRacecardResultNonRunner extends Component {

  static propTypes = {
    nonRunner: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {expanded: false};
  }

  toggleExpanded() {
    this.setState({expanded: !this.state.expanded});
  }

  render(){
    const {
      nonRunner
    } = this.props;

    return (
      <section className="hr-racing-runner-wrapper">
        <div className="hr-racing-runner-position-container">
          <div className="hr-racing-runner-position">
            <div className="row">
              <span className="hr-racing-nonrunner-position-no">{ nonRunner.status === 'WITHDRAWN' ? 'WD' : 'NR' }</span>
            </div>
          </div>
          <div className="hr-racing-runner-space-from-winner"/>
          <div className="hr-racing-nonrunner-cloth-no">
            {nonRunner.saddleClothNo}
          </div>

          <div className="hr-racing-runner-horse-info">
            <div className="row">
              <span className="hr-racing-nonrunner-horse-name">{nonRunner.horseName}</span>
            </div>
            <div className="row">
              <div className="hr-racing-nonrunner-horse-sub-info">
                <span>{nonRunner.horseAge}</span>
                <span>{nonRunner.weight}</span>
              </div>
            </div>
          </div>
          <div className="hr-racing-nonrunner-betting-odds">
            <span className="hr-racing-runner-betting-info">{nonRunner.odds}</span>
          </div>
        </div>

        <div className="hr-racing-nonrunner-form-history-container">
          <div className="hr-racing-nonrunner-form-key-info">
            <div className="hr-racing-nonrunner-form-trainer-jockey-block">
              <span className="hr-racing-nonrunner-form-trainer">T:&nbsp;<span>{nonRunner.trainer.name}</span></span>
              <span className="hr-racing-nonrunner-form-jockey">J:&nbsp;<span>{`${nonRunner.jockey.name} ${nonRunner.jockeyClaim}`}</span></span>
            </div>
          </div>
        </div>

      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardResultNonRunner.js